// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Reporting
const ReAssignForm = () => import('@/modules/reassign/views/ReAssignForm')
const ReAssignPage = () => import('@/modules/reassign/views/ReAssignPage')
const ReAssignOpener = () => import('@/modules/reassign/views/ReAssignOpener')
const ReAssignCloser = () => import('@/modules/reassign/views/ReAssignCloser')

var routes = [
	{
		path: '/reassign',
		redirect: '/reassign/leads',
		name: 'ReAssign',
		component: DefaultContainer,
		children: [
			{
				path: '/reassign/leads',
				name: 'ReAssignForm',
				component: ReAssignForm,
			},
			{
				path: '/reassign/dashboard/company/:companyId/user/:fromAgentId',
				name: 'ReAssignPage',
				component: ReAssignPage,
				meta: {
					tab: 'reassign-dashboard',
				},
				children: [
					{
						path: '/reassign/opener-leads/company/:companyId/user/:fromAgentId',
						name: 'ReAssignOpener',
						component: ReAssignOpener,
						meta: {
							tab: 'reassign-opener-leads',
						},
					},
					{
						path: '/reassign/closer-leads/company/:companyId/user/:fromAgentId',
						name: 'ReAssignCloser',
						component: ReAssignCloser,
						meta: {
							tab: 'reassign-closer-leads',
						},
					},
				]
			}
		]
	},

];


export default routes;
